export interface AdminFilter {
  startDate: string,
  endDate: string,
  component: string,
  entityType: string,
  action: string,
  entityId: string,
  actorId: string,
  actorType: string,
  outcome: string,     
  severity: string[],
  runId: string,
  entityDisplay: string,

}

export const createDefaultFilter = (): AdminFilter => ({
  startDate: '',
  endDate: '',
  component:'',
  entityType:'',
  action:'',
  entityId:'',
  actorId:'',
  actorType: '',
  outcome: '',
  severity: [] as string[],
  runId:'',
  entityDisplay: '',
});

export interface StatData {
  outcome: string,
  count: number,
}
